import { graphql } from 'gatsby'
import React from 'react'

import { PrismicPageDataBodyRecruitingCta } from 'src/typings/generated/graphql'
import RecruitingCta, {
  RecruitingCtaContent,
} from 'src/components/organisms/ctas/recruitingCta'

type Props = {
  slice: PrismicPageDataBodyRecruitingCta
}

const RecruitingCtaSlice = ({ slice }: Props) => {
  const content: RecruitingCtaContent = {
    anchor: slice.primary.anchor ?? undefined,
    headlineImage: slice.primary.headline_image?.gatsbyImageData ?? undefined,
    headlineImageAlt: slice.primary.headline_image?.alt ?? undefined,
    description: slice.primary.description ?? undefined,
    link: slice.primary.link ?? undefined,
    linkText: slice.primary.link_text ?? undefined,
    image: slice.primary.image?.gatsbyImageData ?? undefined,
    imageAlt: slice.primary.image?.alt ?? undefined,
    imageLayout: slice.primary.image_layout ?? undefined,
    backgroundImage:
      slice.primary.background_image?.gatsbyImageData ?? undefined,
    backgroundImageAlt: slice.primary.background_image?.alt ?? undefined,
  }

  return <RecruitingCta content={content} />
}

export default RecruitingCtaSlice

export const recruitingCtaFragment = graphql`
  fragment PageDataBodyRecruitingCta on PrismicPageDataBodyRecruitingCta {
    primary {
      anchor
      headline_image {
        alt
        gatsbyImageData(layout: CONSTRAINED, width: 500)
      }
      description {
        richText
      }
      link_text
      link {
        ...DynamicLinkFragment
      }
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED)
      }
      image_layout
      background_image {
        alt
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`
